/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDepartment } from 'app/shared/model/department.model';
import { IDiaglabBill } from 'app/shared/model/diaglab-bill.model';
import { ITumor } from 'app/shared/model/tumor.model';

export interface ITumorSource {
  id?: string;
  entityId?: string | null;
  entityType?: string;
  entityName?: string | null;
  caseNumber?: string | null;
  caseType?: string | null;
  createdBy?: string | null;
  createDate?: number;
  lastUpdated?: number;
  lastModifiedBy?: string;
  active?: boolean;
  cursor?: number;
  microSec?: number;
  timestampEntry?: number;
  unit?: IDepartment | null;
  test?: IDiaglabBill | null;
  tumor?: ITumor | null;
}

export const defaultValue: Readonly<ITumorSource> = {
  active: false,
};
